'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFetcher$0024$0024anon$00246 from "./presto.-Fetcher$$anon$6.js";
import * as $j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat$0024 from "./presto.-Fetcher$-Unified-Error-Format$.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$$anon$5() {
  this.aTD = null;
  this.aTv = null;
  this.aTw = false;
  this.aTE = null;
  this.aTF = false;
  this.aTI = null;
  this.aTB = null;
  this.aTC = false;
  this.aTx = null;
  this.aTy = false;
  this.aTz = null;
  this.aTA = false;
  this.aTG = false;
  this.aTH = false;
  this.aTD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aTI = "UnifiedErrorFormat";
}
export { $c_Lpresto_Fetcher$$anon$5 as $c_Lpresto_Fetcher$$anon$5 };
$p = $c_Lpresto_Fetcher$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$$anon$5;
/** @constructor */
function $h_Lpresto_Fetcher$$anon$5() {
}
export { $h_Lpresto_Fetcher$$anon$5 as $h_Lpresto_Fetcher$$anon$5 };
$h_Lpresto_Fetcher$$anon$5.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aTD;
});
$p.M = (function() {
  if ((!this.aTw)) {
    this.aTv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aTw = true;
  }
  return this.aTv;
});
$p.O = (function() {
  if ((!this.aTF)) {
    this.aTE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aTF = true;
  }
  return this.aTE;
});
$p.D = (function() {
  return this.aTI;
});
$p.t = (function() {
  if ((!this.aTC)) {
    this.aTB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("message", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("status", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("trace", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aTC = true;
  }
  return this.aTB;
});
$p.N = (function() {
  if ((!this.aTy)) {
    this.aTx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aTy = true;
  }
  return this.aTx;
});
$p.Q = (function() {
  if ((!this.aTA)) {
    this.aTz = new $j_presto$002e$002dFetcher$0024$0024anon$00246.$c_Lpresto_Fetcher$$anon$6();
    this.aTA = true;
  }
  return this.aTz;
});
$p.v = (function() {
  if ((!this.aTH)) {
    this.aTG = false;
    this.aTH = true;
  }
  return this.aTG;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee19) => ((p) => \u03b4scrutinee19.cH2(p)))($j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat$0024.$m_Lpresto_Fetcher$UnifiedErrorFormat$())));
});
var $d_Lpresto_Fetcher$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$$anon$5, "presto.Fetcher$$anon$5", ({
  IC: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Fetcher$$anon$5 as $d_Lpresto_Fetcher$$anon$5 };
//# sourceMappingURL=presto.-Fetcher$$anon$5.js.map
